module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-kia.3503f8c8.png";